import CardService from './card-service';
export default {
  init(node) {
    console.log('CardService Module - webpack');

    CardService.init(node);
  }
};

